<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           $_em-custom-vuex-mixin_vo="purchaseVo"
                                           $_em-custom-vuex-mixin_filter="purchaseFilter"
                                           query-api="purchaseInputQuery"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryStorageInputResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      withCustomRowActions
                                      withCustomRowActionsFirstColumn
                                      $_em-custom-vuex-mixin_vo="purchaseVo"
                                      $_em-custom-vuex-mixin_filter="purchaseFilter"
                                      $_em-custom-vuex-mixin_entity="purchaseEntity"
                                      query-api="purchaseInputQuery"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button
                                        type='search'
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="扫码识别"
                                        showName
                                        @click="openScannerDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-warehouse"
                                               :disabled="$_notChecked"
                                               custom-label="实入上BIN"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openInputDialog()"
                                    >
                                    </em-button>
                                </template>
                                <template #customRowActions="{ row }">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            custom-label="查看打包物料"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoPackingMaterial(row)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{ row }">
                                    <b-button-group>
                                        <em-button
                                            type="edit"
                                            custom-icon="fa fa-fw fa-lg fa-search"
                                            custom-label="分批入厂，收货，退货信息"
                                            class="btn btn-outline-primary btn-sm"
                                            @click="$refs.batchArrivalInfoModal.show(row.poItemId)"
                                        />
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="入库" width="40%" :visible.sync="storageInputDialogVisible" :close-on-click-modal='false'
                   append-to-body @close='clearInputForm' :lock-scroll="false">
            <el-form :model="inputForm" ref="inputForm" label-width="auto" size="mini" :rules="rules">
                <!-- <el-form-item label="库房" prop="storageId">
                    <el-select v-model="inputForm.storageId" placeholder="请选择">
                        <el-option v-for="storage in storageOptions" :key="storage.id" :label="storage.name" :value="storage.id"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="Storage Type" prop="storageType">
                    <el-input v-model="inputForm.storageType"></el-input>
                </el-form-item>
                <el-form-item label="BIN位" prop="binCode">
                    <el-input v-model="inputForm.binCode"></el-input>
                </el-form-item>
                <el-form-item label="BIN位已占容量" prop="binOccupiedCapacity">
                    <el-input v-model="inputForm.binOccupiedCapacity"></el-input>
                </el-form-item>
            </el-form>
            <el-dialog title="扫一扫" :center="true" :visible.sync="binScannerVisible" append-to-body
                       @close="closeBinScanner" :close-on-click-modal='false'>
                <qr-code-scanner ref="binScanner" @getCodeData='getBinInfo'>
                </qr-code-scanner>
            </el-dialog>

            <execute-view-table ref="executeView" :class="showExecuteView?'':'display-none'"
                                style="max-height: 350px;"
                                :entity-name="modelName"
                                :custom-vuex-name="$_customVuexName"
                                :rows="checkedRows">
            </execute-view-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="openBinScanner()">扫描BIN位码</el-button>
                <el-button @click="storageInputDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="storageInput()" :disabled="disableConfirmButton"
                           :loading="batchConfirmInputLoading">确认入库
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body
                   @close="closeScannerDialog" :close-on-click-modal='false'>
            <qr-code-scanner ref="inputScanner" @getCodeData='getInputTask'>
            </qr-code-scanner>
        </el-dialog>
        <inventory-batch-arrival-info-modal ref="batchArrivalInfoModal" />
    </div>
</template>
<script>
// Author Lin
// Date 2021-07-20 17:49:21

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import ExecuteViewTable, {RUN} from "@/components/common/display/ExecuteViewTable.vue";
import InventoryBatchArrivalInfoModal from "@/components/SithMes/inventory/InventoryBatchArrivalInfoModal.vue";

export default {
    name: "sithMesInventoryStorageInputListView",
    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, emTableCheckedMixin],
    components: {InventoryBatchArrivalInfoModal, ExecuteViewTable, qrCodeScanner},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            disableConfirmButton: false,
            storageInputDialogVisible: false,
            storageOptions: [],
            inputForm: {
                storageId: '',
                binCode: '',
                binOccupiedCapacity: '',
                storageType: '',
            },
            rules: {
                storageType: [{required: true, message: '请输入StorageType'}],
                binCode: [{required: true, message: '请输入BIN位'}],
                binOccupiedCapacity: [{required: true, message: '请输入BIN容量'}]
            },
            scannerVisible: false,
            binScannerVisible: false,

            batchConfirmInputLoading: false,
            showExecuteView: false,
        }
    },
    computed: {
        modelName() {
            return "sithMesInventoryStorageInput"
        },
        $_customVuexName() {
            return "purchase";
        },
    },
    methods: {
        openInputDialog() {
            this.storageInputDialogVisible = true;
        },
        clearInputForm() {
            this.inputForm.storageId = '';
            this.inputForm.binCode = '';
            this.inputForm.binOccupiedCapacity = '';
            this.inputForm.storageType = '';
            this.$refs.inputForm.resetFields();
            if (this.showExecuteView) {
                this.$refs.emListFilter.doQuery();
            }
            this.showExecuteView = false;
            this.$refs.executeView.clearRunningStatus();
        },
        getStorageOptions() {
            this.$_emApiMixin_findByFilter("sithMesInventoryWmDefinition", {})
                .then(data => {
                    this.storageOptions = data.map(m => {
                        return {id: m.id, name: m.warehouseNo}
                    })
                })
        },
        storageInput() {
            if (this.batchConfirmInputLoading) {
                return;
            }
            if (this.$_checked) {
                let self = this;
                self.$refs["inputForm"].validate(valid => {
                    if (valid) {
                        self.disableConfirmButton = true;
                        this.batchConfirmInputLoading = true;
                        let ids = this.deepCopyObj(this.checkedItems);
                        this.showExecuteView = true;
                        this.confirmInputOneByOne(ids, self.inputForm, 0);
                    }
                });

            }
        },
        confirmInputOneByOne(ids, form, index) {
            let executeView = this.$refs.executeView;
            if (index >= ids.length) {
                this.disableConfirmButton = false;
                this.batchConfirmInputLoading = false;
                if (executeView.checkAllSuccess()) {
                    executeView.clearRunningStatus();
                    this.storageInputDialogVisible = false;
                    this.$message.success("批处理成功");
                } else {
                    this.$message.warning("批处理完成，存在失败的条目");
                }
                return;
            }
            let id = ids[index];
            if (!executeView.checkSuccess(id)) {
                executeView.setStatus(id, RUN.START);
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryStorageInput")}/confirmInput?ids=${id}`;
                this.$store.dispatch('api/post', {
                    url: url,
                    data: form,
                    commonErrorHandle: false
                }).then((request) => {
                    if (request.status === 200) {
                        executeView.setStatus(id, RUN.DONE);
                    } else {
                        executeView.setStatus(id, RUN.FAILED, "入库失败");
                    }
                }).catch(error => {
                    executeView.setStatus(id, RUN.FAILED, error.response.data.message);
                }).finally(() => {
                    if (!executeView.checkSuccess(id)) {
                        executeView.setStatus(id, RUN.FAILED);
                    }
                    this.confirmInputOneByOne(ids, form, index + 1);
                });
            } else {
                this.confirmInputOneByOne(ids, form, index + 1);
            }
        },
        openScannerDialog() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.inputScanner.openCamera('');
            }, 500);
        },
        openBinScanner() {
            this.binScannerVisible = true;
            setTimeout(() => {
                this.$refs.binScanner.openCamera('');
            }, 500);
        },
        getInputTask(data) {
            console.log("get qr code data:" + data);
            this.scannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var poNumber = obj.PO;
                var item = obj.PoItem;
                var materialCode = obj['物料号'];
                console.log(poNumber);
                console.log(item);
                console.log(materialCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('purchaseNumberFilter', poNumber);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('itemCodeFilter', item);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('poItemMaterialCodeFilter', materialCode);
            this.$refs.emListFilter.doQuery();
        },
        getBinInfo(data) {
            console.log("bin code data:" + data);
            this.binScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var storageType = obj['Storage Type'];
                var storageBin = obj['Storage Bin'];
                console.log(storageType);
                console.log(storageBin);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.inputForm.storageType = storageType;
            self.inputForm.binCode = storageBin;
        },
        closeScannerDialog() {
            this.$refs.inputScanner.closeCamera();
            this.$refs.inputScanner.resetOutputData();
            this.scannerVisible = false;
            this.disableConfirmButton = false;
        },
        closeBinScanner() {
            this.$refs.binScanner.closeCamera();
            this.$refs.binScanner.resetOutputData();
            this.binScannerVisible = false;
            this.disableConfirmButton = false;
        },
        gotoPackingMaterial(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesInventoryPackingBom"
                , {purchaseNumberFilter: row.purchaseNumber, itemCodeFilter: row.itemCode}
                , {}, true, {})
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty("id")) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        }
        // this.getStorageOptions();
    },
};
</script>
<style scoped>
.display-none {
    display: none !important;
}
</style>
